<template>
    <div class="col-md-8 mx-auto">
        <div class="card-header bg-primary text-white">
            <page-title :title="$t('externalServices.title')"></page-title>
        </div>
        <div class="card-body col-12">
            <div class="text-center">
                <div class="btn-group btn-group-vertical" role="group" aria-label="Basic example">
                    <button type="button" class="btn btn-primary"
                            @click="updateCountries"
                            v-bind:disabled="countiesUpdating">
                        <i v-if="countiesUpdating" class="fa fa-spinner fa-pulse fa-fw"></i>
                        {{ $t('externalServices.updateCountries') }}
                    </button>
                    <button type="button" class="btn btn-primary"
                            @click="updateDistricts"
                            v-bind:disabled="districtsUpdating">
                        <i v-if="districtsUpdating" class="fa fa-spinner fa-pulse fa-fw"></i>
                        {{ $t('externalServices.updateDistricts') }}
                    </button>
                    <button type="button" class="btn btn-primary"
                            @click="updateCities"
                            v-bind:disabled="citiesUpdating">
                        <i v-if="citiesUpdating" class="fa fa-spinner fa-pulse fa-fw"></i>
                        {{ $t('externalServices.updateCities') }}
                    </button>
                    <button type="button" class="btn btn-primary"
                            @click="updateResorts"
                            v-bind:disabled="resortsUpdating">
                        <i v-if="resortsUpdating" class="fa fa-spinner fa-pulse fa-fw"></i>
                        {{ $t('externalServices.updateResorts') }}
                    </button>
                    <button type="button" class="btn btn-primary"
                            @click="updateMoodleCategories"
                            v-bind:disabled="moodleCategoriesUpdating">
                        <i v-if="moodleCategoriesUpdating" class="fa fa-spinner fa-pulse fa-fw"></i>
                        {{ $t('externalServices.updateMoodleCategories') }}
                    </button>
                    <button type="button" class="btn btn-primary"
                            @click="clearCache"
                            v-bind:disabled="cacheClearing">
                        <i v-if="cacheClearing" class="fa fa-spinner fa-pulse fa-fw"></i>
                        {{ $t('externalServices.clearCache') }}
                    </button>
                    <button type="button" class="btn btn-primary"
                            @click="syncEventsStaticContent"
                            v-bind:disabled="eventsStaticContentSync">
                        <i v-if="eventsStaticContentSync" class="fa fa-spinner fa-pulse fa-fw"></i>
                        {{ $t('externalServices.eventsStaticContentSync') }}
                    </button>

                    <button type="button" class="btn btn-primary"
                            @click="saveJsLocalicationFiles"
                            v-bind:disabled="jsLocalicationFilesSaving">
                        <i v-if="jsLocalicationFilesSaving" class="fa fa-spinner fa-pulse fa-fw"></i>
                        {{ $t('externalServices.syncLangJsFilesToTheDb') }}
                    </button>

                    <a v-if="hasHangfieRight" class="btn btn-primary" :href="hangfireUrl" target="_blank">Hangfire</a>
                    <a v-if="hasHangfieRight" class="btn btn-primary" :href="elmmahUrl" target="_blank">Elmah</a>

                </div>
            </div>

            <div class="text-center">
                <div class="btn-group btn-group-vertical" role="group" aria-label="Basic example">
                    <button type="button" class="btn btn-primary"
                            @click="testMoodleDbConnection"
                            v-bind:disabled="moodleDbConnectionTesting">
                        <i v-if="moodleDbConnectionTesting" class="fa fa-spinner fa-pulse fa-fw"></i>
                        {{ $t('externalServices.testMoodleDbConnection') }}
                    </button>
                    <button type="button" class="btn btn-primary"
                            @click="testMoodleExtApi"
                            v-bind:disabled="moodleExtApiTesting">
                        <i v-if="moodleExtApiTesting" class="fa fa-spinner fa-pulse fa-fw"></i>
                        {{ $t('externalServices.testMoodleExtApi') }}
                    </button>
                    <button type="button" class="btn btn-primary"
                            @click="testMoodleExtApiCategory"
                            v-bind:disabled="moodleExtApiCategoryTesting">
                        <i v-if="moodleExtApiCategoryTesting" class="fa fa-spinner fa-pulse fa-fw"></i>
                        {{ $t('externalServices.testMoodleExtApiCategory') }}
                    </button>
                </div>
            </div>

            <div class="text-center">
                <div class="btn-group btn-group-vertical" role="group" aria-label="Migration">
                    <button type="button" class="btn btn-primary"
                            @click="migrateActivityNomenclature"
                            v-bind:disabled="activityNomenclatureMigrating">
                        <i v-if="activityNomenclatureMigrating" class="fa fa-spinner fa-pulse fa-fw"></i>
                        {{ $t('externalServices.migrateActivities') }}
                    </button>
                    <button type="button" class="btn btn-primary"
                            @click="migrateDirectorateNomenclature"
                            v-bind:disabled="directorateNomenclatureMigrating">
                        <i v-if="directorateNomenclatureMigrating" class="fa fa-spinner fa-pulse fa-fw"></i>
                        {{ $t('externalServices.migrateDirectorates') }}
                    </button>
                    <button type="button" class="btn btn-primary"
                            @click="migratePositionNomenclature"
                            v-bind:disabled="positionNomenclatureMigrating">
                        <i v-if="positionNomenclatureMigrating" class="fa fa-spinner fa-pulse fa-fw"></i>
                        {{ $t('externalServices.migratePositions') }}
                    </button>
                    <button type="button" class="btn btn-primary"
                            @click="migratePositionStatisticNomenclature"
                            v-bind:disabled="positionStatisticNomenclatureMigrating">
                        <i v-if="positionStatisticNomenclatureMigrating" class="fa fa-spinner fa-pulse fa-fw"></i>
                        {{ $t('externalServices.migrateStatPositions') }}
                    </button>
                    <button type="button" class="btn btn-primary"
                            @click="migrateEmploymentNomenclature"
                            v-bind:disabled="employmentNomenclatureMigrating">
                        <i v-if="employmentNomenclatureMigrating" class="fa fa-spinner fa-pulse fa-fw"></i>
                        {{ $t('externalServices.migrateEmployment') }}
                    </button>
                    <button type="button" class="btn btn-primary"
                            @click="migrateProjectNomenclature"
                            v-bind:disabled="projectNomenclatureMigrating">
                        <i v-if="projectNomenclatureMigrating" class="fa fa-spinner fa-pulse fa-fw"></i>
                        {{ $t('externalServices.migrateProjectName') }}
                    </button>
                    <button type="button" class="btn btn-primary"
                            @click="migrateInstitutionNomenclature"
                            v-bind:disabled="institutionNomenclatureMigrating">
                        <i v-if="institutionNomenclatureMigrating" class="fa fa-spinner fa-pulse fa-fw"></i>
                        {{ $t('externalServices.migrateInstitutions') }}
                    </button>
                    <button type="button" class="btn btn-primary"
                            @click="migrateFundingTypeNomenclature"
                            v-bind:disabled="fundingTypeNomenclatureMigrating">
                        <i v-if="fundingTypeNomenclatureMigrating" class="fa fa-spinner fa-pulse fa-fw"></i>
                        {{ $t('externalServices.migrateFundingType') }}
                    </button>
                    <button type="button" class="btn btn-primary"
                            @click="migrateParticipationTypeNomenclature"
                            v-bind:disabled="participationTypeNomenclatureMigrating">
                        <i v-if="participationTypeNomenclatureMigrating" class="fa fa-spinner fa-pulse fa-fw"></i>
                        {{ $t('externalServices.migrateParticipationType') }}
                    </button>
                    <button type="button" class="btn btn-primary"
                            @click="migrateLegalAreaNomenclature"
                            v-bind:disabled="legalAreaNomenclatureMigrating">
                        <i v-if="legalAreaNomenclatureMigrating" class="fa fa-spinner fa-pulse fa-fw"></i>
                        {{ $t('externalServices.migrateLegalArea') }}
                    </button>
                    <button type="button" class="btn btn-primary"
                            @click="migrateEventTypeNomenclature"
                            v-bind:disabled="eventTypeNomenclatureMigrating">
                        <i v-if="eventTypeNomenclatureMigrating" class="fa fa-spinner fa-pulse fa-fw"></i>
                        {{ $t('externalServices.migrateEventType') }}
                    </button>
                    <button type="button" class="btn btn-primary"
                            @click="migrateEventStatusNomenclature"
                            v-bind:disabled="eventStatusNomenclatureMigrating">
                        <i v-if="eventStatusNomenclatureMigrating" class="fa fa-spinner fa-pulse fa-fw"></i>
                        {{ $t('externalServices.migrateEventStatus') }}
                    </button>
                    <button type="button" class="btn btn-primary"
                            @click="migrateThematicAreaNomenclature"
                            v-bind:disabled="thematicAreaNomenclatureMigrating">
                        <i v-if="thematicAreaNomenclatureMigrating" class="fa fa-spinner fa-pulse fa-fw"></i>
                        {{ $t('externalServices.migrateThematicArea') }}
                    </button>
                    <button type="button" class="btn btn-primary"
                            @click="migrateEventTheme"
                            v-bind:disabled="eventThemeMigrating">
                        <i v-if="eventThemeMigrating" class="fa fa-spinner fa-pulse fa-fw"></i>
                        {{ $t('externalServices.migrateEventTheme') }}
                    </button>
                    <button type="button" class="btn btn-primary"
                            @click="migrateReasonForAdmissionNomenclature"
                            v-bind:disabled="reasonForAdmissionMigrating">
                        <i v-if="reasonForAdmissionMigrating" class="fa fa-spinner fa-pulse fa-fw"></i>
                        {{ $t('externalServices.migrateReasonForParticipation') }}
                    </button>
                    <button type="button" class="btn btn-primary"
                            @click="migrateEdicationNomenclature"
                            v-bind:disabled="educationMigrating">
                        <i v-if="educationMigrating" class="fa fa-spinner fa-pulse fa-fw"></i>
                        {{ $t('externalServices.migrateEducation') }}
                    </button>
                    <button type="button" class="btn btn-primary"
                            @click="migrateTitleNomenclature"
                            v-bind:disabled="titleNomenclatureMigrating">
                        <i v-if="titleNomenclatureMigrating" class="fa fa-spinner fa-pulse fa-fw"></i>
                        {{ $t('externalServices.migrateTitle') }}
                    </button>
                    <button type="button" class="btn btn-primary"
                            @click="migrateOrganizer"
                            v-bind:disabled="organizerMigrating">
                        <i v-if="organizerMigrating" class="fa fa-spinner fa-pulse fa-fw"></i>
                        {{ $t('externalServices.migrateOrganizor') }}
                    </button>
                    <button type="button" class="btn btn-primary"
                            @click="migratePlace"
                            v-bind:disabled="placeMigrating">
                        <i v-if="placeMigrating" class="fa fa-spinner fa-pulse fa-fw"></i>
                        {{ $t('externalServices.migratePlaces') }}
                    </button>
                    <button type="button" class="btn btn-primary"
                            @click="migrateEvents"
                            v-bind:disabled="eventsMigrating">
                        <i v-if="eventsMigrating" class="fa fa-spinner fa-pulse fa-fw"></i>
                        {{ $t('externalServices.migrateEvents') }}
                    </button>
                    <button type="button" class="btn btn-primary"
                            @click="migrateParticipants"
                            v-bind:disabled="participantsMigrating">
                        <i v-if="participantsMigrating" class="fa fa-spinner fa-pulse fa-fw"></i>
                        {{ $t('externalServices.migrateParticipants') }}
                    </button>
                    <button type="button" class="btn btn-primary"
                            v-bind:disabled="lectorsMigrating"
                            @click="migrateLectors">
                        <i v-if="lectorsMigrating" class="fa fa-spinner fa-pulse fa-fw"></i>
                        {{ $t('externalServices.migrateLecturers') }}
                    </button>

                    <!--<button type="button" class="btn btn-primary"
                            @click="selectParticipantsImportFiles"
                            v-bind:disabled="participantsMigrating">
                        <i v-if="participantsMigrating" class="fa fa-spinner fa-pulse fa-fw"></i>
                        Миграция на участници
                    </button>-->
                    <!--<button type="button" class="btn btn-primary"
                            @click="test">
                    </button>-->

                    <hr />
                    <button v-if="isDeveloper"
                            type="button" class="btn btn-primary"
                            v-bind:disabled="nomPreparing"
                            @click.stop="onNomenclaturePrep">
                        <i v-if="nomPreparing" class="fa fa-spinner fa-pulse fa-fw"></i>
                        Nomenclature prepare
                    </button>
                    <button v-if="isDeveloper"
                            type="button" class="btn btn-primary"
                            v-bind:disabled="nomTweaking"
                            @click.stop="onNomenclatureTweak">
                        <i v-if="nomTweaking" class="fa fa-spinner fa-pulse fa-fw"></i>
                        Nomenclature tweak
                    </button>
                    <button v-if="isDeveloper"
                            type="button" class="btn btn-primary"
                            v-bind:disabled="institutionTweaking"
                            @click.stop="onInstitutionTweak">
                        <i v-if="institutionTweaking" class="fa fa-spinner fa-pulse fa-fw"></i>
                        Institutions tweak
                    </button>
                </div>

                <input type="file" id="importParticipantsFile" class="selectFile" @change="goToImportParticipantsFromExcel" />
            </div>
        </div>

        <EditModal v-model="resultString" :show="showSuccess" @onClose="onSuccessClose"></EditModal>
        <JsonFormatter
            v-model="moodleExtApiTestResult"
            :show.sync="showMoodleExtApiTestResult"
            :titleKey="'externalServices.testMoodleExtApi'"
            @onClose="onMoodleExtApiTestResultClose"
        />

        <JsonFormatter
            v-model="moodleExtApiCategoryTestResult"
            :show.sync="showMoodleExtApiCategoryTestResult"
            :titleKey="'externalServices.testMoodleExtApiCategory'"
            @onClose="onMoodleExtApiCategoryTestResultClose"
        />
    </div>

</template>

<script>
    import PageTitle from '@/components/common/PageTitle';
    import EditModal from '@/components/administration/edit.modal';
    import langService from '@/services/lang.service';
    import JsonFormatter from "@/components/common/json.formatter.modal.vue";
    import bg from '../../language/bg';
    import en from '../../language/en';
    import { mapGetters } from 'vuex';

    export default {
        components: { PageTitle, EditModal, JsonFormatter },
        data() {
            return {
                showSuccess: false,
                resultString: '',
                countiesUpdating: false,
                districtsUpdating: false,
                citiesUpdating: false,
                resortsUpdating: false,
                eventsMigrating: false,
                activityNomenclatureMigrating: false,
                directorateNomenclatureMigrating: false,
                positionNomenclatureMigrating: false,
                positionStatisticNomenclatureMigrating: false,
                employmentNomenclatureMigrating: false,
                projectNomenclatureMigrating: false,
                institutionNomenclatureMigrating: false,
                fundingTypeNomenclatureMigrating: false,
                participationTypeNomenclatureMigrating: false,
                thematicAreaNomenclatureMigrating: false,
                legalAreaNomenclatureMigrating: false,
                eventTypeNomenclatureMigrating: false,
                eventStatusNomenclatureMigrating: false,
                eventThemeMigrating: false,
                participantsMigrating: false,
                titleNomenclatureMigrating: false,
                moodleCategoriesUpdating: false,
                cacheClearing: false,
                eventsStaticContentSync: false,
                reasonForAdmissionMigrating: false,
                educationMigrating: false,
                organizerMigrating: false,
                placeMigrating: false,
                lectorsMigrating: false,
                jsLocalicationFilesSaving: false,
                moodleDbConnectionTesting: false,
                nomPreparing: false,
                nomTweaking: false,
                institutionTweaking: false,
                bg: bg,
                en: en,
                moodleExtApiTesting: false,
                showMoodleExtApiTestResult: false,
                moodleExtApiTestResult: "",
                moodleExtApiCategoryTesting: false,
                showMoodleExtApiCategoryTestResult: false,
                moodleExtApiCategoryTestResult: "",
            }
        },
        computed: {
            ...mapGetters(['isAuthenticated', 'claims', 'authToken', 'baseUrl', 'isDeveloper']),
            hasHangfieRight() {
                return this.isAuthenticated && this.claims.hangfire.read;
            },
            hangfireUrl() {
                return `${this.baseUrl}/background/hangfire?access_token=${this.authToken}`;
            },
            elmmahUrl() {
                return `${this.baseUrl}/background/elmah?access_token=${this.authToken}`;
            }
        },
        methods: {
            onSuccessClose() {
                this.showSuccess = false;
            },
            saveJsLocalicationFiles() {
                this.jsLocalicationFilesSaving = true;

                langService.saveJsLocalizationFiles({ merge: true, bgContent: JSON.stringify(this.bg), enContent: JSON.stringify(this.en) })
                    .then(response => {
                        this.$vs.notify({
                            title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })
                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    })
                    .then(() => {
                        this.jsLocalicationFilesSaving = false;
                    });
            },
            updateCountries() {
                this.countiesUpdating = true;

                this.$http.post(`/api/Nomenclatures/CountriesUpdate`)
                    .then(response => {
                        this.countiesUpdating = false;

                        this.$vs.notify({
                            title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })

                        this.resultString = "Държави - успешно обновяване";
                        this.showSuccess = true;
                    }).catch(error => {
                        this.countiesUpdating = false;

                        this.$vs.notify({
                            title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })

                        this.resultString = `Държави - ${this.$helpers.errorText(error)}`;
                        this.showSuccess = true;
                    });
            },
            updateDistricts() {
                this.districtsUpdating = true;

                this.$http.post(`/api/Cities/DistrictsUpdate`)
                    .then(response => {
                        this.districtsUpdating = false;

                        this.$vs.notify({
                            title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })
                    }).catch(error => {
                        this.districtsUpdating = false;

                        this.$vs.notify({
                            title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            updateCities() {
                this.citiesUpdating = true;

                this.$http.post(`/api/Cities/CitiesUpdate`)
                    .then(response => {
                        this.citiesUpdating = false;

                        this.$vs.notify({
                            title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })
                    }).catch(error => {
                        this.citiesUpdating = false;

                        this.$vs.notify({
                            title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            updateMoodleCategories() {
                this.moodleCategoriesUpdating = true;

                this.$http.post(`/api/Migration/UpdateMoodleCategoriesNomenclature`)
                    .then(response => {
                        this.moodleCategoriesUpdating = false;

                        this.$vs.notify({
                            title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })
                    }).catch(error => {
                        this.moodleCategoriesUpdating = false;

                        this.$vs.notify({
                            title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            updateResorts() {
                this.citiesUpdating = true;

                this.$http.post(`/api/Cities/ResortsUpdate`)
                    .then(response => {
                        this.citiesUpdating = false;

                        this.$vs.notify({
                            title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })
                    }).catch(error => {
                        this.citiesUpdating = false;

                        this.$vs.notify({
                            title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            migrateEvents() {
                this.eventsMigrating = true;

                this.$http.post(`/api/Migration/UpdateEvents`, {})
                    .then(response => {
                        this.eventsMigrating = false;

                        this.$vs.notify({
                            title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })

                        this.resultString = `Събития - успешна миграция`;
                        this.showSuccess = true;
                    }).catch(error => {
                        this.eventsMigrating = false;

                        this.$vs.notify({
                            title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })

                        this.resultString = `Събития - ${this.$helpers.errorText(error)}`;
                        this.showSuccess = true;
                    });
            },
            migrateLectors() {
                this.lectorsMigrating = true;
                this.$http.post(`/api/Migration/MigrateLectors`, {})
                    .then(response => {
                        this.lectorsMigrating = false;
                        this.$vs.notify({
                            title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })

                        this.resultString = `Лектори - успешна миграция`;
                        this.showSuccess = true;
                    }).catch(error => {
                        this.lectorsMigrating = false;
                        this.$vs.notify({
                            title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })

                        this.resultString = `Лектори - ${this.$helpers.errorText(error)}`;
                        this.showSuccess = true;
                    });
            },
            migrateActivityNomenclature() {
                this.activityNomenclatureMigrating = true;

                this.$http.post(`/api/Migration/UpdateActivityNomenclature`, {})
                    .then(response => {
                        this.activityNomenclatureMigrating = false;

                        this.$vs.notify({
                            title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })

                        this.resultString = `Дейност - успешна миграция`;
                        this.showSuccess = true;
                    }).catch(error => {
                        this.activityNomenclatureMigrating = false;

                        this.$vs.notify({
                            title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })

                        this.resultString = `Дейност - ${this.$helpers.errorText(error)}`;
                        this.showSuccess = true;
                    });
            },
            migrateDirectorateNomenclature() {
                this.directorateNomenclatureMigrating = true;

                this.$http.post(`/api/Migration/UpdateDirectorateNomenclature`, {})
                    .then(response => {
                        this.directorateNomenclatureMigrating = false;

                        this.$vs.notify({
                            title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })

                        this.resultString = `Дирекция - успешна миграция`;
                        this.showSuccess = true;
                    }).catch(error => {
                        this.directorateNomenclatureMigrating = false;

                        this.$vs.notify({
                            title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })

                        this.resultString = `Дирекция - ${this.$helpers.errorText(error)}`;
                        this.showSuccess = true;
                    });
            },
            migratePositionNomenclature() {
                this.positionNomenclatureMigrating = true;

                this.$http.post(`/api/Migration/UpdatePositionNomenclature`, {})
                    .then(response => {
                        this.positionNomenclatureMigrating = false;

                        this.$vs.notify({
                            title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })

                        this.resultString = `Длъжност - успешна миграция`;
                        this.showSuccess = true;
                    }).catch(error => {
                        this.positionNomenclatureMigrating = false;

                        this.$vs.notify({
                            title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })

                        this.resultString = `Длъжност - ${this.$helpers.errorText(error)}`;
                        this.showSuccess = true;
                    });
            },
            migratePositionStatisticNomenclature() {
                this.positionStatisticNomenclatureMigrating = true;

                this.$http.post(`/api/Migration/UpdatePositionStatisticNomenclature`, {})
                    .then(response => {
                        this.positionStatisticNomenclatureMigrating = false;

                        this.$vs.notify({
                            title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })

                        this.resultString = `Длъжност статистически цели - успешна миграция`;
                        this.showSuccess = true;
                    }).catch(error => {
                        this.positionStatisticNomenclatureMigrating = false;

                        this.$vs.notify({
                            title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })

                        this.resultString = `Длъжност статистически цели - ${this.$helpers.errorText(error)}`;
                        this.showSuccess = true;
                    });
            },
            migrateEmploymentNomenclature() {
                this.employmentNomenclatureMigrating = true;

                this.$http.post(`/api/Migration/UpdateEmploymentNomenclature`, {})
                    .then(response => {
                        this.employmentNomenclatureMigrating = false;

                        this.$vs.notify({
                            title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })

                        this.resultString = `Заетост - успешна миграция`;
                        this.showSuccess = true;
                    }).catch(error => {
                        this.employmentNomenclatureMigrating = false;

                        this.$vs.notify({
                            title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })

                        this.resultString = `Заетост - ${this.$helpers.errorText(error)}`;
                        this.showSuccess = true;
                    });
            },
            migrateProjectNomenclature() {
                this.projectNomenclatureMigrating = true;

                this.$http.post(`/api/Migration/UpdateProjectNomenclature`, {})
                    .then(response => {
                        this.projectNomenclatureMigrating = false;

                        this.$vs.notify({
                            title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })

                        this.resultString = `Име на проект - успешна миграция`;
                        this.showSuccess = true;
                    }).catch(error => {
                        this.projectNomenclatureMigrating = false;

                        this.$vs.notify({
                            title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })

                        this.resultString = `Име на проект - ${this.$helpers.errorText(error)}`;
                        this.showSuccess = true;
                    });
            },
            migrateInstitutionNomenclature() {
                this.institutionNomenclatureMigrating = true;

                this.$http.post(`/api/Migration/UpdateInstitutionNomenclature`, {})
                    .then(response => {
                        this.institutionNomenclatureMigrating = false;

                        this.$vs.notify({
                            title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })

                        this.resultString = `Институция - успешна миграция`;
                        this.showSuccess = true;
                    }).catch(error => {
                        this.institutionNomenclatureMigrating = false;

                        this.$vs.notify({
                            title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })

                        this.resultString = `Институция - ${this.$helpers.errorText(error)}`;
                        this.showSuccess = true;
                    });
            },
            migrateFundingTypeNomenclature() {
                this.fundingTypeNomenclatureMigrating = true;

                this.$http.post(`/api/Migration/UpdateFundingTypeNomenclature`, {})
                    .then(response => {
                        this.fundingTypeNomenclatureMigrating = false;

                        this.$vs.notify({
                            title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })

                        this.resultString = `Финансиране - успешна миграция`;
                        this.showSuccess = true;
                    }).catch(error => {
                        this.fundingTypeNomenclatureMigrating = false;

                        this.$vs.notify({
                            title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })

                        this.resultString = `Финансиране - ${this.$helpers.errorText(error)}`;
                        this.showSuccess = true;
                    });
            },
            migrateParticipationTypeNomenclature() {
                this.participationTypeNomenclatureMigrating = true;

                this.$http.post(`/api/Migration/UpdateParticipationTypeNomenclature`, {})
                    .then(response => {
                        this.participationTypeNomenclatureMigrating = false;

                        this.$vs.notify({
                            title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })

                        this.resultString = `Тип участие - успешна миграция`;
                        this.showSuccess = true;
                    }).catch(error => {
                        this.participationTypeNomenclatureMigrating = false;

                        this.$vs.notify({
                            title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })

                        this.resultString = `Тип участие - ${this.$helpers.errorText(error)}`;
                        this.showSuccess = true;
                    });
            },
            migrateThematicAreaNomenclature() {
                this.thematicAreaNomenclatureMigrating = true;

                this.$http.post(`/api/Migration/UpdateThematicAreaNomenclature`, {})
                    .then(response => {
                        this.thematicAreaNomenclatureMigrating = false;

                        this.$vs.notify({
                            title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })

                        this.resultString = `Тематична област - успешна миграция`;
                        this.showSuccess = true;
                    }).catch(error => {
                        this.thematicAreaNomenclatureMigrating = false;

                        this.$vs.notify({
                            title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })

                        this.resultString = `Тематична област - ${this.$helpers.errorText(error)}`;
                        this.showSuccess = true;
                    });
            },
            migrateLegalAreaNomenclature() {
                this.legalAreaNomenclatureMigrating = true;

                this.$http.post(`/api/Migration/UpdateLegalAreaNomenclature`, {})
                    .then(response => {
                        this.legalAreaNomenclatureMigrating = false;

                        this.$vs.notify({
                            title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })

                        this.resultString = `Правна област - успешна миграция`;
                        this.showSuccess = true;
                    }).catch(error => {
                        this.legalAreaNomenclatureMigrating = false;

                        this.$vs.notify({
                            title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })

                        this.resultString = `Правна област - ${this.$helpers.errorText(error)}`;
                        this.showSuccess = true;
                    });
            },
            migrateEventTypeNomenclature() {
                this.eventTypeNomenclatureMigrating = true;

                this.$http.post(`/api/Migration/UpdateEventTypeNomenclature`, {})
                    .then(response => {
                        this.eventTypeNomenclatureMigrating = false;

                        this.$vs.notify({
                            title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })

                        this.resultString = `Вид събитие - успешна миграция`;
                        this.showSuccess = true;
                    }).catch(error => {
                        this.eventTypeNomenclatureMigrating = false;

                        this.$vs.notify({
                            title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })

                        this.resultString = `Вид събитие - ${this.$helpers.errorText(error)}`;
                        this.showSuccess = true;
                    });
            },
            migrateEventStatusNomenclature() {
                this.eventStatusNomenclatureMigrating = true;

                this.$http.post(`/api/Migration/UpdateEventStatusNomenclature`, {})
                    .then(response => {
                        this.eventStatusNomenclatureMigrating = false;

                        this.$vs.notify({
                            title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })

                        this.resultString = `Статус събитие - успешна миграция`;
                        this.showSuccess = true;
                    }).catch(error => {
                        this.eventStatusNomenclatureMigrating = false;

                        this.$vs.notify({
                            title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })

                        this.resultString = `Статус събитие - ${this.$helpers.errorText(error)}`;
                        this.showSuccess = true;
                    });
            },
            migrateEventTheme() {
                this.eventThemeMigrating = true;

                this.$http.post(`/api/Migration/UpdateEventThemes`, {})
                    .then(response => {
                        this.eventThemeMigrating = false;

                        this.$vs.notify({
                            title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })

                        this.resultString = `Теми на събитие - успешна миграция`;
                        this.showSuccess = true;
                    }).catch(error => {
                        this.eventThemeMigrating = false;

                        this.$vs.notify({
                            title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })

                        this.resultString = `Теми на събитие - ${this.$helpers.errorText(error)}`;
                        this.showSuccess = true;
                    });
            },
            migrateParticipants() {
                this.participantsMigrating = true;

                this.$http.post(`/api/Migration/UpdateParticipants`, {})
                    .then(response => {
                        this.participantsMigrating = false;

                        this.$vs.notify({
                            title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })

                        this.resultString = `Участници - успешна миграция`;
                        this.showSuccess = true;
                    }).catch(error => {
                        this.participantsMigrating = false;

                        this.$vs.notify({
                            title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })

                        this.resultString = `Участници - ${this.$helpers.errorText(error)}`;
                        this.showSuccess = true;
                    });
            },
            selectParticipantsImportFiles() {
                var dialog = $("#importParticipantsFile");
                dialog.trigger("click");
            },
            goToImportParticipantsFromExcel(args) {
                this.participantsMigrating = true;
                var $input = $("#importParticipantsFile")[0];
                var files = $input.files;
                if (files && files.length > 0) {
                    var filename = files[0].name;
                    var file = files[0];

                    // clear the selected file so that the change event triggers when the same file is selected
                    $input.value = null;

                    var formData = new FormData();
                    formData.append('FileName', filename);
                    formData.append('FileContent', file);

                    this.$http.post('/api/migration/migrateParticipants', formData).then(response => {
                        this.participantsMigrating = false;

                        if (response.data.hasErrors) {
                            this.$vs.notify({
                                title: this.$t('request.response.status.400'),
                                text: this.$t('invalidAction'),
                                color: 'danger',
                                time: this.$store.getters.notificationDuration
                            })

                            const blob = new Blob([response.data.data]);
                            const url = window.URL.createObjectURL(blob);
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', 'Errors.txt'); // or any other extension
                            document.body.appendChild(link);
                            link.click();

                            return;
                        }

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })
                    }).catch(error => {
                        this.participantsMigrating = false;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })
                    });
                }
            },
            migrateTitleNomenclature() {
                this.titleNomenclatureMigrating = true;

                this.$http.post(`/api/Migration/UpdateTitleNomenclature`, {})
                    .then(response => {
                        this.titleNomenclatureMigrating = false;

                        this.$vs.notify({
                            title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })

                        this.resultString = `Титла(звание) - успешна миграция`;
                        this.showSuccess = true;
                    }).catch(error => {
                        this.titleNomenclatureMigrating = false;

                        this.$vs.notify({
                            title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })

                        this.resultString = `Титла(звание) - ${this.$helpers.errorText(error)}`;
                        this.showSuccess = true;
                    });
            },
            migrateReasonForAdmissionNomenclature() {
                this.reasonForAdmissionMigrating = true;

                this.$http.post(`/api/Migration/UpdateReasonForAdmissionNomenclature`, {})
                    .then(response => {
                        this.reasonForAdmissionMigrating = false;

                        this.$vs.notify({
                            title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })

                        this.resultString = `Основание за участие - успешна миграция`;
                        this.showSuccess = true;
                    }).catch(error => {
                        this.reasonForAdmissionMigrating = false;

                        this.$vs.notify({
                            title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })

                        this.resultString = `Основание за участие - ${this.$helpers.errorText(error)}`;
                        this.showSuccess = true;
                    });
            },
            migrateEdicationNomenclature() {
                this.educationMigrating = true;

                this.$http.post(`/api/Migration/UpdateEducationNomenclature`, {})
                    .then(response => {
                        this.educationMigrating = false;

                        this.$vs.notify({
                            title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })

                        this.resultString = `Образование - успешна миграция`;
                        this.showSuccess = true;
                    }).catch(error => {
                        this.educationMigrating = false;

                        this.$vs.notify({
                            title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })

                        this.resultString = `Образование - ${this.$helpers.errorText(error)}`;
                        this.showSuccess = true;
                    });
            },
            migrateOrganizer() {
                this.organizerMigrating = true;

                this.$http.post(`/api/Migration/UpdateOrganizer`, {})
                    .then(response => {
                        this.organizerMigrating = false;

                        this.$vs.notify({
                            title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })

                        this.resultString = `Организатор - успешна миграция`;
                        this.showSuccess = true;
                    }).catch(error => {
                        this.organizerMigrating = false;

                        this.$vs.notify({
                            title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })

                        this.resultString = `Организатор - ${this.$helpers.errorText(error)}`;
                        this.showSuccess = true;
                    });
            },
            migratePlace() {
                this.placeMigrating = true;

                this.$http.post(`/api/Migration/UpdatePlace`, {})
                    .then(response => {
                        this.placeMigrating = false;

                        this.$vs.notify({
                            title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })

                        this.resultString = `Място на провеждане - успешна миграция`;
                        this.showSuccess = true;
                    }).catch(error => {
                        this.placeMigrating = false;

                        this.$vs.notify({
                            title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })

                        this.resultString = `Място на провеждане - ${this.$helpers.errorText(error)}`;
                        this.showSuccess = true;
                    });
            },
            clearCache() {
                this.cacheClearing = true;

                this.$http.get(`/api/cacheManagement/clearAllCache`)
                    .then(response => {
                        this.cacheClearing = false;

                        this.$vs.notify({
                            title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })
                    }).catch(error => {
                        this.cacheClearing = false;

                        this.$vs.notify({
                            title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            syncEventsStaticContent() {
                this.eventsStaticContentSync = true;

                this.$http.get(`/api/events/syncStaticContent`)
                    .then(response => {
                        this.eventsStaticContentSync = false;

                        this.$vs.notify({
                            title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })
                    }).catch(error => {
                        this.eventsStaticContentSync = false;

                        this.$vs.notify({
                            title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            testMoodleDbConnection() {
                this.moodleDbConnectionTesting = true;

                this.$http.get(`/api/moodle/testMoodleDbConnection`)
                    .then(response => {
                        this.$vs.notify({
                            title: this.$t('externalServices.testMoodleDbConnection'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })
                    }).catch(error => {
                        this.$vs.notify({
                            title: this.$t('externalServices.testMoodleDbConnection'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })
                    })
                    .then(() => { this.moodleDbConnectionTesting = false; });
            },
            testMoodleExtApi() {
                this.moodleExtApiTesting = true;
                this.moodleExtApiTestResult = "";

                this.$http.get(`/api/moodle/TestMoodleExtApi`)
                    .then(response => {
                        this.moodleExtApiTestResult = response.data;
                        this.showMoodleExtApiTestResult = true;
                        this.$vs.notify({
                            title: this.$t('externalServices.testMoodleExtApi'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })
                    }).catch(error => {
                        this.$vs.notify({
                            title: this.$t('externalServices.testMoodleExtApi'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })
                    })
                    .then(() => { this.moodleExtApiTesting = false; });
            },
            testMoodleExtApiCategory() {
                this.moodleExtApiCategoryTesting = true;
                this.moodleExtApiCategoryTestResult = "";

                this.$http.get(`/api/moodle/TestMoodleExtCategoryApi`)
                    .then(response => {
                        this.moodleExtApiCategoryTestResult = response.data;
                        this.showMoodleExtApiCategoryTestResult = true;
                        this.$vs.notify({
                            title: this.$t('externalServices.testMoodleExtApiCategory'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })
                    }).catch(error => {
                        this.$vs.notify({
                            title: this.$t('externalServices.testMoodleExtApiCategory'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })
                    })
                    .then(() => { this.moodleExtApiCategoryTesting = false; });
            },
            test() {
                this.titleNomenclatureMigrating = true;

                this.$http.get(`/api/cacheManagement/clearAllCache`)
                    .then(response => {
                        this.titleNomenclatureMigrating = false;

                        this.$vs.notify({
                            title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })
                    }).catch(error => {
                        this.titleNomenclatureMigrating = false;

                        this.$vs.notify({
                            title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })
                    });


                // this.titleNomenclatureMigrating = true;

                // this.$http.get(`/api/dynamicRegisters/GetEventsDetailsForKnownFieldCodes`, {})
                //    .then(response => {
                //        this.titleNomenclatureMigrating = false;

                //        this.$vs.notify({
                //            title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                //            text: this.$helpers.responseMessage(response),
                //            color: 'success',
                //            time: this.$store.getters.notificationDuration,
                //        })
                //    }).catch(error => {
                //        this.titleNomenclatureMigrating = false;

                //        this.$vs.notify({
                //            title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                //            text: this.$helpers.errorText(error),
                //            color: 'danger',
                //            time: this.$store.getters.notificationDuration
                //        })
                //    });
            },
            onNomenclaturePrep() {
                this.nomPreparing = true;

                this.$http.get(`/api/test/NomeclaturePrep`)
                    .then(response => {
                        this.$vs.notify({
                            title: 'Nomenclature preparing',
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })
                    }).catch(error => {
                        console.log(error.response);
                        this.$vs.notify({
                            title: 'Nomenclature preparing',
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })
                    })
                    .then(() => { this.nomPreparing = false; });
            },
            onNomenclatureTweak() {
                this.nomTweaking = true;

                this.$http.get(`/api/test/NomeclatureTweak`)
                    .then(response => {
                        this.$vs.notify({
                            title: 'Nomenclature tweaking',
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })
                    }).catch(error => {
                        console.log(error.response);
                        this.$vs.notify({
                            title: 'Nomenclature tweaking',
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })
                    })
                    .then(() => { this.nomTweaking = false; });
            },
            onInstitutionTweak() {
                this.institutionTweaking = true;

                this.$http.get(`/api/test/InstitutionTweak`)
                    .then(response => {
                        this.$vs.notify({
                            title: 'Institution tweaking',
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })
                    }).catch(error => {
                        console.log(error.response);
                        this.$vs.notify({
                            title: 'Institution tweaking',
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })
                    })
                    .then(() => { this.institutionTweaking = false; });
            },
            onMoodleExtApiTestResultClose() {
                this.moodleExtApiTestResult = "";
                this.showMoodleExtApiTestResult = false;
            },
            onMoodleExtApiCategoryTestResultClose() {
                this.moodleExtApiCategoryTestResult = "";
                this.showMoodleExtApiCategoryTestResult = false;
            }

        }
    }
</script>

